import React from 'react';
import { Button, CircularProgress } from "@mui/material";
import { FaCheck, FaPlus, FaDownload } from "react-icons/fa";

const ActionButtons = ({ 
  selectedEntries, 
  loading, 
  approveSelected, 
  addNewEntry, 
  exportData 
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          variant="contained"
          onClick={approveSelected}
          disabled={
            selectedEntries.length === 0 || loading.approveEntries
          }
          startIcon={
            loading.approveEntries ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <FaCheck />
            )
          }
        >
          {loading.approveEntries ? "Approving..." : "Approve Selected"}
        </Button>
        <Button
          variant="outlined"
          onClick={addNewEntry}
          startIcon={<FaPlus />}
        >
          Add New Entry
        </Button>
      </div>
      <div style={{ display: "flex", gap: "8px" }}>
        <Button variant="outlined" onClick={() => exportData("csv")}>
          <FaDownload style={{ marginRight: "8px" }} />
          Export CSV
        </Button>
        <Button variant="outlined" onClick={() => exportData("pdf")}>
          <FaDownload style={{ marginRight: "8px" }} />
          Export PDF
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;